import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "visitor" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 　 ")
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['info', 'grid--horizontal'])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_code_scanner = _resolveComponent("code-scanner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_visitor_profile = _resolveComponent("visitor-profile")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_photo_taker = _resolveComponent("photo-taker")!
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_wrapper_footer = _resolveComponent("wrapper-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_code_scanner, {
              codeType: 'qrcode',
              model: _ctx.scanModel,
              preview: false
            }, null, 8, ["model"])
          ]),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                image: "/img/svg/scan.svg",
                description: _ctx.trans('message.visitor_no-matched')
              }, null, 8, ["description"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([
			'visitor',
			'visitor-reg-validation',
			'grid--vertical',
			{ visible: _ctx.show }
		])
    }, [
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.trans("label.visitor-profile")) + " ", 1),
          (_ctx.expired)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: "danger",
                effect: "dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.trans("label.card-expired")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_3,
          (_ctx.isVRDeleted)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                type: "danger",
                effect: "dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.trans("label.card-deleted")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form, {
              "label-position": "top",
              model: _ctx.model,
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_visitor_profile, {
                  model: _ctx.model,
                  ref: "visitorProfile"
                }, null, 8, ["model"])
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_el_card, { class: "binding-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_photo_taker, {
                  model: _ctx.model,
                  callback: _ctx.updateVisitorImage,
                  ref: "photoTaker"
                }, null, 8, ["model", "callback"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_visiting_companies, {
        ref: "visitingCompanies",
        records: _ctx.visitCompanies
      }, null, 8, ["records"])
    ], 2),
    _createVNode(_component_wrapper_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/dashboard')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.cancel")), 1)
          ]),
          _: 1
        }),
        (_ctx.show && _ctx.showAllowEntryBtn)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "warning",
              onClick: _ctx.allowVisit
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.allow-entry")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}